module.exports = __webpack_public_path__ + "static/architecture-visual-5c72375d8664966e98a99192e4cafd02.png";